import React, { Component } from 'react'
import { connect } from 'react-redux'
import Divider from 'material-ui/Divider'
import dataActions from 'actions/dataActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import newCommentActions from 'actions/newCommentActions'
import { dirtyRead, doc, edit, routing, login } from 'selectors/common'
import BillFormLeftSide from './BillForm/LeftSide'
import InvoiceFormLeftSide from './InvoiceForm/LeftSide'
import PaymentFormLeftSide from './PaymentForm/LeftSide'
import DepositFormLeftSide from './DepositForm/LeftSide'
import BillFormRightSide from './BillForm/RightSide'
import InvoiceFormRightSide from './InvoiceForm/RightSide'
import PaymentFormRightSide from './PaymentForm/RightSide'
import DepositFormRightSide from './DepositForm/RightSide'
import attachmentActions from 'actions/attachmentActions'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import Deleted from 'components/Deleted'
import TransactionStatusIcon from '../transactions/StatusIcon'
import { invalid } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => {
		return {
			doc: doc(state, props.id || props.routeParams.id)
  	  	  , invalid: invalid(state, props.id || props.routeParams.id) || false
		}
	}
)

export class Transaction extends Component{
	render(){
			let { props } = this
			let doc = props.doc || {}
			let types = {
				'transaction/bill': {leftSide: BillFormLeftSide, rightSide: BillFormRightSide}
				,'transaction/invoice': {leftSide: InvoiceFormLeftSide , rightSide: BillFormRightSide}
				,'transaction/invoice-payment': {leftSide: PaymentFormLeftSide , rightSide: PaymentFormRightSide}
				,'transaction/invoice-deposit': {leftSide: DepositFormLeftSide , rightSide: DepositFormRightSide}
			}
			let LeftSide = (types[doc.type] || {}).leftSide || PaymentFormLeftSide
			let RightSide = (types[doc.type] || {}).rightSide || PaymentFormRightSide
			let transactionID = this.props.id || this.props.routeParams.id
			let colspan = this.props.colspan || 2
			let widthColumns = "100%" //(this.props.style && this.props.width && colspan)?(this.props.width.split('px')[0]/colspan)-18+"px":"50%"
			let status
			if (doc.type=='transaction/bill') {
				status = doc.paymentConfirmed ? 'Paid and confirmed' : doc.qbidNew || doc.qbid ? 'Sent to payment system' : 'Waiting for sync'
			} else if (doc.type=='transaction/invoice'){
				status = doc.paymentConfirmed ? 'Paid and confirmed' : doc.qbid || doc.qbidNew ? 'Sent to payment system' : 'Waiting for sync'
			} else {
				status = ''
			}

			return (
				<div
					style={{
						display: "inline-block"
					  , width: "100%"
					  , backgroundColor: "#FFF"
					  , overflow: "hidden"
					}}
				>
					<FormHeader
						title={(!this.props.doc
							?"Transaction ":doc.type=='transaction/bill'
							?"Bill: "
							:doc.type=='transaction/invoice'
							?"Invoice: "
							:doc.type=='transaction/invoice'
							?"Invoice "
							:"Payment ")
							+ status
						}







						statusIcon={<div style={{position:"relative", top:"-7px"}}><TransactionStatusIcon transactionID={transactionID} /></div>}
						masterDetail={this.props.masterDetail || false}
						objectID= {transactionID}
						commitDisabled={!!props.invalid}
					/>
					{(!this.props.doc)?
						<Deleted />
						:
						<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden", backgroundColor: "#f3f5f4"}}>
						<main style={{height:"calc(100vh - 64px)", display:(colspan>1)?"flex":"block"}}>
							<LeftSide transactionID={transactionID} colspan={colspan} editable={status == 'Waiting for sync'}/>
							{colspan==1 && <Divider style={{marginTop: "0px"}}/>}
							<RightSide transactionID={transactionID} colspan={colspan}/>
						</main>
						{transactionID &&
							<div
								style={{
									position:"fixed"
							      , zIndex:"9999"
								  , bottom:"3px"
								  , right:"17px"
								  , boxSizing: "borderBox"
								  , maringRight: "17px"
								}}
							>
								<FormFooter masterDetail={this.props.masterDetail || false} deleteDisabled={(status && status !== 'Waiting for sync')} commitDisabled={!!props.invalid} objectID={transactionID} />
							</div>
						}
						</div>
					}

				</div>
			)
	}
}

export default connect(select)(Transaction)
//export default connect(select, {...dataActions, ...attachmentOverlayActions, ...attachmentActions, ...newCommentActions, ...rightStackActions})(Transaction)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/index.js